import { useMemo, useState } from 'react'
import { getResponsiveImageProps } from '../../lib/images'

type Props = {
  src: string
  alt: string
  className?: string
  widths?: number[]
  sizes: string
  quality?: number
}

/** Panel thumbnails: Supabase resize when available, fallback to original URL on error. */
export function PanelThumbnailImage({
  src,
  alt,
  className,
  widths = [320, 480, 640],
  sizes,
  quality = 72,
}: Props) {
  const raw = src.trim()
  const renderProps = useMemo(
    () =>
      getResponsiveImageProps({
        src: raw,
        widths,
        sizes,
        quality,
        useSupabaseImageRender: true,
      }),
    [raw, widths, sizes, quality],
  )
  const [fallbackRaw, setFallbackRaw] = useState(false)

  if (!raw) return null

  const imgProps = fallbackRaw ? { src: raw, sizes } : renderProps

  return (
    <img
      {...imgProps}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      fetchPriority="low"
      onError={() => {
        if (!fallbackRaw) setFallbackRaw(true)
      }}
    />
  )
}
